import React, { useContext } from 'react';
import { ThemeContext } from '../../contexts/ThemeContext';
import { LanguageContext } from '../../contexts/LanguageContext';
import { 
  StyledServices, 
  ServiceCategories, 
  ServicesGrid, 
  ServiceCard,
  SectionSubtitle 
} from './styles';

const Services = () => {
  const { theme } = useContext(ThemeContext);
  const { language, translations } = useContext(LanguageContext);

  const backofficeServices = [
    {
      icon: 'fas fa-folder',
      title: 'documentManagement',
      description: 'documentManagementDesc'
    },
    {
      icon: 'fas fa-calendar-check',
      title: 'deadlineControl',
      description: 'deadlineControlDesc'
    },
    {
      icon: 'fas fa-tasks',
      title: 'operationalSupport',
      description: 'operationalSupportDesc'
    },
    {
      icon: 'fas fa-database',
      title: 'dataOrganization',
      description: 'dataOrganizationDesc'
    }
  ];

  const researchServices = [
    {
      icon: 'fas fa-newspaper',
      title: 'publications',
      description: 'publicationsDesc'
    },
    {
      icon: 'fas fa-sync-alt',
      title: 'caseUpdates',
      description: 'caseUpdatesDesc'
    },
    {
      icon: 'fas fa-bell',
      title: 'electronicSummons',
      description: 'electronicSummonsDesc'
    },
    {
      icon: 'fas fa-search',
      title: 'distributionsAndInquiries',
      description: 'distributionsAndInquiriesDesc'
    }
  ];

  return (
    <StyledServices id="servicos">
      <div className="container">
        <h2 dangerouslySetInnerHTML={{ __html: translations[language].servicesTitle }} />

        <ServiceCategories>
          <SectionSubtitle>{translations[language].legalBackoffice}</SectionSubtitle>
          <ServicesGrid>
            {backofficeServices.map((service, index) => (
              <ServiceCard key={index} data-aos="fade-up" data-aos-delay={index * 50}>
                <div className="icon">
                  <i className={service.icon}></i>
                </div>
                <h3>{translations[language][service.title]}</h3>
                <p>{translations[language][service.description]}</p>
              </ServiceCard>
            ))}
          </ServicesGrid>
        </ServiceCategories>

        <ServiceCategories style={{ marginTop: '60px' }}>
          <SectionSubtitle>{translations[language].legalResearch}</SectionSubtitle>
          <ServicesGrid>
            {researchServices.map((service, index) => (
              <ServiceCard key={index} data-aos="fade-up" data-aos-delay={index * 50}>
                <div className="icon">
                  <i className={service.icon}></i>
                </div>
                <h3>{translations[language][service.title]}</h3>
                <p>{translations[language][service.description]}</p>
              </ServiceCard>
            ))}
          </ServicesGrid>
        </ServiceCategories>
      </div>
    </StyledServices>
  );
};

export default Services;
